import { Injectable } from '@angular/core';
import { Observable, of,  map, catchError } from 'rxjs';
import { AjaxService } from '../../../../../services/ajax.service';
import { ViewScopeService } from '../../../../../services/view-scope.service';
import { LOAD_BUSINESS_TYPE, LOAD_ACCOUNTS_TYPE, LOAD_ACTIVITY_TYPE, CREATE_ACCOUNT} from '../../../../../services/account-api.constants';
import { SelectItem } from '../../../../../models/selected-item.model';

export interface BasicInfo {
	businessId: string;
	businessType: string;
	entityType: string;
	contactName: string;
	contactTitle: string;
	ownerFirstName: string;
	ownerLastName: string;
	establishedDate: Date | null;
	unionBusinessId: string;
	note: string;
	description: string;
	smallExpenseValue: number;
	isActive: boolean;
	isApproved: boolean;
}

@Injectable({ providedIn: 'root' })
export class BasicInfoService {
	constructor(private ajaxService: AjaxService,
				private viewScopeService: ViewScopeService) { }

	saveBasicInfo(info: BasicInfo): Observable<boolean> {
		// Replace with real HTTP call
		console.log('Saving basic info:', info);
		return of(true);
	}

	public getBusinessTypeData(): Observable<SelectItem[]> 
	{
		const url = this.ajaxService.getBaseOfApi() + LOAD_BUSINESS_TYPE +  this.viewScopeService.getCurrentOpertaingUserId().toString();
		return this.ajaxService.getData(url).pipe(
			map((response: any) => {
				return (response || []).map((item: any) => ({
					label: item.BusinessType, 
					value: item.BusinessType, 
					code: item.RecID
				})) as SelectItem[];
			})
		);
	}

	public getAccountTypeData(): Observable<SelectItem[]> {
		const url = this.ajaxService.getBaseOfApi() + LOAD_ACCOUNTS_TYPE + this.viewScopeService.getCurrentOpertaingUserId().toString();
		return this.ajaxService.getData(url).pipe(
			map((response: any) => {
				return (response || []).map((item: any) => ({
					label: item.Status, 
					value: item.Status, 
					code: item.Code, // 100 - Customer, 200 - supplier.
					aditionalData1 : item.RecID // RecID 1 customer.
				})) as SelectItem[];
			})
		);
	}


	public getActivityType(): Observable<SelectItem[]>
	{
		const url = this.ajaxService.getBaseOfApi() + LOAD_ACTIVITY_TYPE + this.viewScopeService.getCurrentOpertaingUserId().toString();
		return this.ajaxService.getData(url).pipe(
			map((response: any) => {
				return (response || []).map((item: any) => ({
					label: item.Status, 
					value: item.Status, 
					code: item.RecID,
					aditionalData1: item.Code
				})) as SelectItem[];
			})
		);
	}

	public createAnAccount(payload: any): Observable<any> 
	{
		const url = this.ajaxService.getBaseOfApi() + CREATE_ACCOUNT;
		return this.ajaxService.addObjectData(url, payload);
	}

	public getSpecificOptionFromAC(code: number | string = 200): Observable<SelectItem | null>
	{
		return this.getAccountTypeData().pipe(
			map((items: SelectItem[]) => {
				const supplier = (items || []).find(i => i.code == code);
				return supplier ?? null;
			}),
			catchError(() => of(null))
		);
	}

	public getSpecificActivityOption(code: number | string = 100): Observable<SelectItem | null>
	{
		return this.getActivityType().pipe(
			map((items: SelectItem[]) => {
				const option = (items || []).find(i => i.aditionalData1 == code);
				return option ?? null;
			}),
			catchError(() => of(null))
		);
	}
}